import React from "react";
import styled from "styled-components";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";

const Loading = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LoadingButton = (props) => {
  const { isLoading, variant, ...rest } = props;
  console.log("Loading button variant", variant, rest);
  let muiVariant = variant == "primary" ? "contained" : variant;
  if (isLoading) {
    return (
      <Button {...rest} variant={muiVariant} disabled={true}>
        {props.children}
        <Loading>
          <CircularProgress size={20} color="secondary" />
        </Loading>
      </Button>
    );
  } else {
    return <Button {...rest} variant={muiVariant} />;
  }
};

LoadingButton.defaultProps = {
  variant: "contained",
  size: "medium",
  color: "primary",
  type: "submit",
};

export default LoadingButton;
